<div class="topbar bg-primary-blue p-0 py-2">
  <!-- <nav class="topbar-custom d-flex justify-content-between" [class.nav-sticky]="scrollY > 50" id="topbar-custom"></nav> -->
  <nav class="topbar-custom d-flex justify-content-between" id="topbar-custom">
    <ul class="topbar-item list-unstyled d-inline-flex mb-0">
      <li class="d-flex flex-column">

        @if(userInfo.type==1){
        <!-- Normal size -->
        <span class="fs-5 fw-bold d-none d-sm-block text-primary-red">{{"welcome"|translate}}</span>
        <!-- Extra small for <300px -->
        <span class="fs-5 fw-bold d-block d-sm-none text-primary-red">{{"welcome"|translate}}</span>
        }

        @if(userInfo.type==2){
        <!-- Normal size -->
        <span class="fs-5 fw-bold d-none d-sm-block text-primary-red">{{"welcome"|translate}}</span>
        <!-- Extra small for <300px -->
        <span class="fs-5 fw-bold d-block d-sm-none text-primary-red">{{"welcome"|translate}}</span>
        <span class="fs-6 fw-bold d-none d-sm-block text-dark">{{"subAgent"|translate}}</span>
        <!-- Extra small for <300px -->
        <span class="fs-5 fw-bold d-block d-sm-none text-dark">{{"subAgent"|translate}}</span>
        }
        @if(userInfo.type==4){
        <!-- Normal size -->
        <span class="fs-5 fw-bold d-none d-sm-block text-primary-red">{{"welcome"|translate}}</span>
        <!-- Extra small for <300px -->
        <span class="fs-5 fw-bold d-block d-sm-none text-primary-red">{{"welcome"|translate}}</span>
        <span class="fs-6 fw-bold d-none d-sm-block text-dark">{{"regionalManager"|translate}}</span>
        <!-- Extra small for <300px -->
        <span class="fs-5 fw-bold d-block d-sm-none text-dark">{{"regionalManager"|translate}}</span>
        }
        <!-- <span class="fs-4 fw-bold d-none d-sm-block text-light">{{ userInfo.name}} {{ userInfo.lastName}}</span>
        <span class="fs-3 fw-bold d-block d-sm-none text-light">{{ userInfo.name}} {{ userInfo.lastName}}</span> -->
      </li>
    </ul>
    <ul class="topbar-item list-unstyled d-inline-flex align-items-center mb-0">
      <!-- <li class="hide-phone app-search">
          <form role="search" action="#" method="get">
            <input type="search" name="search" class="form-control top-search mb-0" placeholder="Buscar aqui..." />
            <button type="button"><i class="iconoir-search"></i></button>
          </form>
        </li> -->
      <!-- <li class="dropdown" ngbDropdown>
          <a class="d-flex flex-column align-items-center gap-1 nav-link dropdown-toggle arrow-none nav-icon"
            ngbDropdownToggle data-bs-toggle="dropdown" href="javascript:void(0);" role="button" aria-haspopup="false"
            aria-expanded="false">
            <img [src]="defaultLanguageImage" alt="" class="thumb-md rounded-circle" />
          </a>
          <div class="dropdown-menu" ngbDropdownMenu>
            <a class="dropdown-item" (click)="changeLanguage('es', 'assets/images/flags/spain_flag.jpg')"
              href="javascript:void(0);"><img src="assets/images/flags/spain_flag.jpg" alt="" height="15"
                class="me-2" />{{
              'spanish' | translate }}</a>
            <a class="dropdown-item" (click)="changeLanguage('en', 'assets/images/flags/us_flag.jpg')"
              href="javascript:void(0);"><img src="assets/images/flags/us_flag.jpg" alt="" height="15" class="me-2" />{{
              'english' |
              translate }}</a>
            <a class="dropdown-item" (click)="changeLanguage('fr', 'assets/images/flags/french_flag.jpg')"
              href="javascript:void(0);"><img src="assets/images/flags/french_flag.jpg" alt="" height="15"
                class="me-2" />{{
              'french' |
              translate }}</a>
            <a class="dropdown-item" (click)="changeLanguage('hat', 'assets/images/flags/haiti_flag.png')"
              href="javascript:void(0);"><img src="assets/images/flags/haiti_flag.png" alt="" height="15"
                class="me-2" />{{
              'creole' |
              translate }}</a>
          </div>
        </li> -->
      <!--end topbar-language-->

      <!-- <li class="topbar-item">
          <a class="nav-link nav-icon" (click)="changeTheme()" href="javascript:void(0);" id="light-dark-mode">
            <i class="icofont-sun dark-mode"></i>
            <i class="icofont-moon light-mode"></i>
          </a>
        </li> -->

      <li class="dropdown topbar-item">
        <a class="nav-link dropdown-toggle arrow-none nav-icon" (click)="goToNotifications()" href="javascript:void(0);"
          role="button">
          @if(notificationsCount){
          <span class="badge bg-danger text-light badge-pill ms-1 position-absolute" style="top: 30px; right: -3px;">
            {{notificationsCount}}
          </span>
          }
          <i class="icofont-bell-alt"></i>
          <span class="alert-badge"></span>
        </a>
      </li>
      <li class="dropdown topbar-item" [routerLink]="userInfo?.type == 1 
  ? '/user/user' 
  : userInfo?.type == 2 
    ? '/subagent/user' 
    : '/regional-manager/user'">
        <a class="nav-link dropdown-toggle arrow-none nav-icon" href="javascript:void(0);" role="button">
          <img [src]="'https://resources.bencash.net/'+initialPreviewUrl" class="bg-light-blue rounded-circle"
            style="height: 3rem; object-fit: contain; width: 3rem;" />
        </a>
      </li>

      <!-- <li class="dropdown topbar-item" ngbDropdown placement="bottom-end" routerLink="/tabs/user">
        <a class="nav-link dropdown-toggle arrow-none nav-icon" ngbDropdownToggle data-bs-toggle="dropdown"
          href="javascript:void(0);" role="button" aria-haspopup="false" aria-expanded="false">
          <img src="assets/images/users/profile-icon.jpg" [width]="100" alt="" class="thumb-lg rounded-circle" />
        </a>
        <div class="dropdown-menu dropdown-menu-end py-0" ngbDropdownMenu>
          <div class="d-flex align-items-center dropdown-item py-2 bg-secondary-subtle">
            <div class="flex-shrink-0">
              <img src="assets/images/users/profile-icon.jpg" [width]="100" alt="" class="thumb-md rounded-circle" />
            </div>
            <div class="flex-grow-1 ms-2 text-truncate align-self-center">
              <h6 class="my-0 fw-medium text-dark fs-13">{{userName}}</h6>
              <small class="text-muted mb-0">Front End Developer</small>
            </div>
          </div>
          <div class="dropdown-divider mt-0"></div>
          <small class="text-muted px-2 pb-1 d-block">{{"account"| translate}}</small>
          <a class="dropdown-item" routerLink="/pages/profile"><i class="las la-user fs-18 me-1 align-text-bottom"></i>
            {{"profile"| translate}}</a>
          <a class="dropdown-item" routerLink="/apps/ecommerce/orders"><i
              class="las la-wallet fs-18 me-1 align-text-bottom"></i>
            Earning</a>
          <small class="text-muted px-2 py-1 d-block">Settings</small>
          <a class="dropdown-item" routerLink="/pages/profile"><i
              class="las la-cog fs-18 me-1 align-text-bottom"></i>Account
            Settings</a>
          <a class="dropdown-item" routerLink="/auth/lock-screen" target="_blank"><i
              class="las la-lock fs-18 me-1 align-text-bottom"></i> Lock</a>
          <a class="dropdown-item" routerLink="/pages/faqs"><i
              class="las la-question-circle fs-18 me-1 align-text-bottom"></i>
            Help Center</a>
          <div class="dropdown-divider mb-0"></div>
          <a class="dropdown-item text-danger" (click)="logout()"><i
              class="las la-power-off fs-18 me-1 align-text-bottom"></i>
            {{"logout"| translate}}</a>
        </div>
      </li> -->
    </ul>
    <!--end topbar-nav-->
  </nav>
  <!-- end navbar-->
</div>